import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { gameDetailsActions } from '../../store/gameDetailsSlice';
import { gamesFiltersModalActions } from '../../store/gamesFiltersModalSlice';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { useGetMunicipalitiesQuery } from '../../store/services/municipalitiesServices';
import { useGetNACCodesQuery } from '../../store/services/nacServices';
import { useNavigate } from 'react-router';
import { Calendar } from 'react-date-range';
import { LuSearch, LuFileText, LuX } from "react-icons/lu";
import { FiSearch } from 'react-icons/fi';
import { gameCancelModalActions } from '../../store/gameCancelModal';
import { useCancelGameMutation } from '../../store/services/gameServices';
import { openModalWithTimeout } from '../../store/alertSlice';

const customStyles = {
    content: {
        position: 'static',
        borderRadius: '10px',
        padding: '0px',
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
};

Modal.setAppElement(document.getElementById('root'))

export default function GameCancelModal({ params, handleApplyAdvancedParams }) {

    const isOpen = useSelector(state => state.game_cancel_modal.isOpen)
    const data = useSelector(state => state.game_cancel_modal.data)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [cancelReason, setCancelReason] = useState('');
    const [pdfFile, setPdfFile] = useState(null);
    const [cancelGame] = useCancelGameMutation();

    const closeModal = () => {
        setCancelReason('');
        setPdfFile(null);
        dispatch(gameCancelModalActions.closeModal())
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type === 'application/pdf') {
            setPdfFile(file);
        } else if (file) {
            alert('Ju lutem ngarkoni vetëm skedarë PDF');
            e.target.value = '';
        }
    };

    const handleRemoveFile = () => {
        setPdfFile(null);
    };

    const handleCancelSubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append('cancel_reason', cancelReason);
            if (pdfFile) {
                formData.append('file', pdfFile);
            }

            const response = await cancelGame({ id: data.game_id, data: formData }).unwrap();
            dispatch(openModalWithTimeout({
                type: 'success',
                text: 'Loja u anulua me sukses!'
            }))
            closeModal();
        }
        catch (error) {
            console.error("Failed to cancel game:", error);
            dispatch(openModalWithTimeout({
                type: 'error',
                // An ended game (e.g. auto-ended after its last tier was drawn) can no longer be canceled
                text: error?.data?.error === 'Only an active game can be canceled!'
                    ? 'Vetëm një lojë aktive mund të anulohet!'
                    : 'Gabim gjatë anulimit të lojës'
            }))
        }
    }

    return (
        <div>
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div className="bg-white p-8 w-[600px] text-sm relative">
                    <form onSubmit={handleCancelSubmit}>
                        <div className='flex flex-col gap-4'>
                            <h1 className='font-semibold text-lg'>A jeni të sigurtë se doni të anuloni lojën?</h1>
                            <textarea required className='max-h-48 w-full h-48 border min-h-48 p-3 rounded-lg outline-none' placeholder='Shkruani arsyen e anulimit këtu' value={cancelReason} onChange={(e) => setCancelReason(e.target.value)}></textarea>

                            <div className='flex flex-col gap-2'>
                                <label className='font-semibold'>Ngarko vendimin (PDF)</label>
                                {!pdfFile ? (
                                    <label className='w-full p-3 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-gray-400 transition-colors flex items-center justify-center'>
                                        <input
                                            type='file'
                                            accept='application/pdf'
                                            onChange={handleFileChange}
                                            className='hidden'
                                        />
                                        <span className='text-gray-500'>Kliko për të ngarkuar PDF</span>
                                    </label>
                                ) : (
                                    <div className='w-full p-3 border border-gray-300 rounded-lg flex items-center justify-between bg-gray-50'>
                                        <div className='flex items-center gap-2'>
                                            <LuFileText className='text-red-600' size={20} />
                                            <span className='text-sm font-medium truncate'>{pdfFile.name}</span>
                                        </div>
                                        <button
                                            type='button'
                                            onClick={handleRemoveFile}
                                            className='text-gray-500 hover:text-red-600 transition-colors'
                                        >
                                            <LuX size={20} />
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div className='flex gap-4 items-center'>
                                <div className='w-full p-2 text-center bg-gray-100 hover:brightness-[0.95] rounded-lg cursor-pointer' onClick={closeModal}>Kthehu</div>
                                <input type='submit' className='w-full p-2 text-center bg-red-700 hover:brightness-[1.1] text-white rounded-lg cursor-pointer' value='Konfirmo' />
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
        </div>
    )
}